export const fetchProjectHeaderRecords = (projects) => {
  // Return action
  return {
    // Unique identifier
    type: 'GET_PROJECT_HEADERS',
	projects: projects
	//orders: normalize(orders, orderSchema)
  }
};